import { io } from "socket.io-client";
import constants from "utils/constants";

const accessToken = localStorage.getItem(constants.KEY_LOCAL_TOKEN);

export const socket = io(process.env.AZ_SOCKET_URL, {
  query: `accessToken=${accessToken}`
});
